<template>
  <tr :class="rowBgClass">
    <td class="font-size-0875-rem text-no-wrap text-left">{{ title }}</td>
    <td
      v-for="summary, index in summaryList"
      :key="index"
      class="px-2 font-size-0875-rem text-right"
    >
      {{ summary }}
    </td>
    <td class="px-2 font-size-0875-rem font-weight-bold text-right">{{ summaryTotal }}</td>
  </tr>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue"

export default defineComponent({
  name: "YearlySummaryRow",
  props: {
    summaryType: {
      type: String,
      required: true
    },
    rowTitle: {
      type: String,
      required: true
    },
    summaryList: {
      type: Array,
      required: true
    },
    summaryTotal: {
      type: Number,
      required: true
    },
  },
  setup(props) {
    const title = computed(() => props.rowTitle as string)
    const summaryList = computed(() => props.summaryList as Array<string>)
    const summaryTotal = computed(() => props.summaryTotal as number)
    const rowBgClass = computed(() => {
      switch (props.summaryType) {
        case 'syounika':
          return 'bg-syounika'
        case 'obstetrics':
          return 'bg-obstetrics'
        case 'medicineQuestion':
          return 'bg-medicine-question'
        default:
          return ''
      }
    })

    return {
      title,
      summaryList,
      summaryTotal,
      rowBgClass
    }
  }
})
</script>
